module.exports = __webpack_public_path__ + "static/media/hapticGoRoundImg1.3f8f42f7.jpg";